import React from "react";
import ContactForm from './ContactForm';

function ContactMe() {
    return (
        <> 
            <ContactForm />  
        </>
    );
}

export default ContactMe;
